import { getToken } from "src/shared/utils/common";

export class CommandSetAdMediaFile {
  async run(adId: number, file: File, metadata: any) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/media_file/`;

    const formData = new FormData();
    formData.append("media_file", file);
    formData.append("metadata", JSON.stringify(metadata))

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Token ${getToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
      }
    } catch (err) {
      console.error("Error uploading media file:", err);
      throw err;
    }
  }
}
